import React, { Component } from 'react';
import { Flex } from 'antd-mobile';
import dayjs from "dayjs";
import Rsrush from './rsrush';
import Rskash from './rskash';
import MxTifi from './mx-tifi';
import DocMap from './doc';
import { setAliasApp } from '@/utils/utils';

class LoanContract extends Component {
  constructor(props) {
    super(props);
    const app = setAliasApp((props.match.params.app || 'tifi'));

    this.state = {
      loanData: {},
      app,
    }
  }

  // 初始化
  componentDidMount() {
    document.title = 'Loan Sanction Letter';
  }

  getMxTifi () {
    return MxTifi({
      date: dayjs().format("DD-MM-YYYY"),
      name: window.android ? window.android.getUserFullName() : '--',
      companyName: window.android ? window.android.getCompanyName() : '--',
      amount: window.android ? window.android.getUserLoanAmount() : '--',
    })
  }

  getTifi () {
    let doc = []
    for(let i = 0; i < 9; i++) {
      doc.push(<img key={ i } src={ `https://static-mx.obs.myhuaweicloud.com/web/app-h5/app/tifi/loan-contract/${ i + 1 }.png` } alt="mib" />)
    }
    return doc
  }
  getKeTifi () {
    return DocMap['tifi-ke'] || ''
  }
  getChamploan () {
    return DocMap['champloan'] || ''
  }

  render() {
    const { app } = this.state;
    let doc = ''
    switch (app) {
      case 'rskash':
        doc = <Rskash />
        break;
      case 'rsrush':
        doc = <Rsrush />
        break;
      case 'tifi2': // 兼容旧版本
        doc = <Flex className='doc' direction='column'>
          <Flex.Item className='body'
            dangerouslySetInnerHTML={{ __html: this.getMxTifi() }}
          >
          </Flex.Item>
        </Flex>
        break;
      case 'tifi':
        doc = <Flex className='doc' direction='column'>
          <Flex.Item className='body'>
            <h2>Contract</h2>
            { this.getTifi() }
          </Flex.Item>
        </Flex>
        break;
      case 'tifi-ke':
        doc = <Flex className='doc' direction='column'>
          <Flex.Item className='body' 
            dangerouslySetInnerHTML={{ __html: this.getKeTifi() }}>
          </Flex.Item>
        </Flex>
        break;
      case 'champloan':
        doc = <Flex className='doc' direction='column'>
          <Flex.Item className='body' 
            dangerouslySetInnerHTML={{ __html: this.getChamploan() }}>
          </Flex.Item>
        </Flex>
        break;
      // 添加tifislice_ke协议判断逻辑2021-12-15
      case 'tifislice':
        doc = <Flex className='doc' direction='column'>
          <Flex.Item className='body'>
            <h2>Contract</h2>
            { this.getTifi() }
          </Flex.Item>
        </Flex>
        break;
        // 添加tifislice_ke协议判断逻辑2021-12-15
        case '9jaCash':
          doc = <Flex className='doc' direction='column'>
            <Flex.Item className='body'>
              <h2>Contract</h2>
              { this.getTifi() }
            </Flex.Item>
          </Flex>
          break;
      default:
        break;
    }
    return <div className={ app + ' loan-contract' }>
      { doc }
    </div>
  }
}

export default LoanContract;

